(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mbe-future-shop-system"] && !Shopify.designMode) return;
  try {
    const initMbeFutureShop = () => {
    const body = document.body;
    if (!body.classList.contains('mbe-future-shop')) return;

    const productKicker = document.querySelector('[data-mbe-product-kicker]');
    const productTitle = document.querySelector('.product-details h1');
    if (productKicker && productTitle) {
      productTitle.parentElement.insertBefore(productKicker, productTitle);
      productKicker.hidden = false;
    }

    const collectionKicker = document.querySelector('[data-mbe-collection-kicker]');
    const collectionTitle = document.querySelector("main > .shopify-section:first-child h1");
    if (collectionKicker && collectionTitle) {
      collectionTitle.parentElement.insertBefore(collectionKicker, collectionTitle);
      collectionKicker.hidden = false;
    }

    const cartAssurance = document.querySelector('[data-mbe-cart-assurance]');
    const cartSummary = document.querySelector('.cart-page__summary');
    if (cartAssurance && cartSummary) {
      cartSummary.prepend(cartAssurance);
      cartAssurance.hidden = false;
    }

    const cards = document.querySelectorAll('.product-card');
    cards.forEach((card) => {
      if (card.dataset.mbePointerReady) return;
      card.dataset.mbePointerReady = 'true';
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        card.style.setProperty('--mbe-x', `${event.clientX - rect.left}px`);
        card.style.setProperty('--mbe-y', `${event.clientY - rect.top}px`);
      });
    });

    const sections = document.querySelectorAll('main .shopify-section');
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -5% 0px' }
    );
    sections.forEach((section, index) => {
      if (index === 0 || section.classList.contains('mbe-future-reveal')) {
        section.classList.add('is-visible');
        return;
      }
      section.classList.add('mbe-future-reveal');
      revealObserver.observe(section);
    });

    let progressFrame = 0;
    const updateProgress = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const progress = max > 0 ? window.scrollY / max : 0;
      body.style.setProperty('--mbe-scroll', Math.min(1, Math.max(0, progress)));
      progressFrame = 0;
    };
    const requestProgress = () => {
      if (progressFrame) return;
      progressFrame = requestAnimationFrame(updateProgress);
    };
    window.addEventListener('scroll', requestProgress, { passive: true });
    updateProgress();
  };

  initMbeFutureShop();
  document.addEventListener('shopify:section:load', initMbeFutureShop);
  } catch(e) { console.error(e); }
})();

})();
